import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { CERTIFICATES_FEATURE_KEY } from './keys';
import { certificatesReducer } from './reducers/certificates.reducer';
import { CertificatesEffects } from './effects/certificates.effects';

export const certificatesStoreProviders = [provideState(CERTIFICATES_FEATURE_KEY, certificatesReducer), provideEffects(CertificatesEffects)];

export { CertificatesFacade } from './facades/certificates.facade';
export * from './models';
